export default __webpack_public_path__ + "static/media/burstofaggression.703e73a8.png";